module.exports = __webpack_public_path__ + "static/media/madfit-4.00e21b54.jpg";